import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { HttpUtils } from '../../../../common/http/http-utils';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
const _ = require('lodash');
const INTERVAL = 2000;

@Injectable()
export class ICCService {
    public isInterconnectConfigured;
    private vcList: any;
    private dcList: any;
    private value: any;
    private depContUrlAdmin = '/admin/hybridity/api/global/deploymentContainers';
    private depContUrl = '/hybridity/api/compute/';
    private interconnectServiceMeshAPIUrl: string = '/hybridity/api/interconnect/serviceMesh';
    private _isConfigured = new Subject<boolean>();
    
    constructor(public http: HttpClient) {
        this.isInterconnectConfigured = this._isConfigured.asObservable();
    }
    //New Start

    public getFleetConfig(siteId) {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/interconnectConfig/site/' + siteId)
            .map((res:any) => {
                const data = res;
                this._isConfigured.next(data.resourceDetails && data.resourceDetails.length > 0);
                return data;
            });
    }

    public getInterconnectServiceMeshList(vcGuid: string) {
        const URL = HttpUtils.getBaseUrl() + this.interconnectServiceMeshAPIUrl + '?vcGuid=' + vcGuid;
        return this.http.get(URL);
    }

    public getDeploymentContainers() {
        return this.http
        .get(HttpUtils.getBaseUrl() + this.depContUrlAdmin)
        .map(res => res);
    }

    public getNetworkBackings (vcId: string = '') {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/admin/hybridity/api/compute/'+ vcId+'?filter=unused&backingType=all')
            // .get(HttpUtils.getBaseUrl() + '/admin/hybridity/api/compute/networkBackings')
            
            .map(res => res);
    }

    public createInterConnectConfig(fleetConfigSchemaObject,resourceId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/interconnectConfig/resource/'+resourceId;
        return this.http.post(url, fleetConfigSchemaObject);
    };

    public getInterConnectConfig(resourceId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/interconnectConfig/resource/' + resourceId;
        return this.http.get(url);
    };

    public updateInterConnectConfig(fleetConfigSchemaObject,resourceId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/interconnectConfig/resource/' + resourceId;
        return this.http.put(url, fleetConfigSchemaObject).map((res) => {
           res;
        });
    };


    public deleteFleetConfig(siteId) {
        let url = HttpUtils.getBaseUrl() + '/admin/hybridity/api/interconnectConfig/site/' + siteId;
        return this.http
        .delete(url);
     }

    //  hybridity/api/fleetConfig/resource/{resourceId}
     public deleteFleetConfigByResourceId(resourceId) {
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/interconnectConfig/resource/' + resourceId;
        return this.http
        .delete(url);
     }


    public getVcList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
            .map(res => this.vcList = res);
    }

    public getDVPGs(resourcePoolId:string, vcGuid:string){
        const dvpgQeury: string = "/hybridity/api/service/inventory/vc/networks?computeType=ResourcePool&compute="+resourcePoolId+"&vcenterId="+vcGuid;
        return this.http.get(dvpgQeury).map((res:any) => {
            let dvpgs = res.dvpgs;
            let filterDpgs = _.filter(dvpgs, function(data){
                return (data.name.indexOf("vxw") === -1);
            });
            return filterDpgs;
        });
    }

    public getVirtualWires(vcGuid:string){
        const virtualWireQuery: string = "/hybridity/api/virtualwires?vcenterId="+vcGuid;
        return this.http.get(virtualWireQuery).map((res) => {
            if(res !== ""){
                return res;
            } else {
                return [];
            }
        });
    }

    public getDatastores(vcGuid:string, computeId:string , cloudUrl?: string) {
        let config = {
            'filter': {
                'computeType': 'ClusterComputeResource',
                'computeId': computeId,
                'vcenter_instanceId': vcGuid
            }
        }
        let path:string = HttpUtils.getBaseUrl() + '/hybridity/api/service/inventory/vc/datastores/query';
        return this.http.post(path,config).map((res:any) => {
            let items = res.data.items;
            let filteredItems = _.filter(items, function(item){
                return (item.accessible && item.maintenanceMode === 'normal');
            })
            return filteredItems;
        });
    }

    public getComputeProfile(vcGuid:string) {
        let path:string = HttpUtils.getBaseUrl() + '/hybridity/api/interconnect/computeProfiles?'+vcGuid;
        return this.http.get(path).map((res)=>res); 
    }

    public getNSXIPPools(vcGuid:string){
        let path:string = HttpUtils.getBaseUrl() + '/hybridity/api/nsxIpPools?vcenterId='+vcGuid;
        return this.http.get(path).map((res)=>res); 
    }

    public getLogicalNetworkconfiguration(){
        let path:string = HttpUtils.getBaseUrl() + '/admin/hybridity/api/global/config';
        return this.http.get(path).map((res)=>{
            return res || {};
        });
    }

    public getStandardPortGroups(vcGuid: string, computeIds: string[]) {
        const body = {
                filter: {
                    computeType: 'ClusterComputeResource',
                    computeIds,
                    vcenter_instanceId: vcGuid
                }
        };
        let dvSwitchQueryPath:string = "/hybridity/api/service/inventory/vc/vswitch/query"
        return this.http.post(dvSwitchQueryPath, body).map( (res) => res);
    }

    public getResourcePools(vcGuid:string){
        let getResourcePoolpath = "/hybridity/api/vc/query?entityType=resourcePool&filter=vcenterId==" + vcGuid;
        return this.http.get(getResourcePoolpath).map((res)=> res);
    }

    public transformInterconnectConfigToServiceMesh(){
        let url = HttpUtils.getBaseUrl() + '/hybridity/api/interconnectConfig/transform';
        return this.http.post(url, {}).map((res)=> res);
    }

    public getInterconnectTaskById(interconnectTaskId) {
        const URL = HttpUtils.getBaseUrl() + "/hybridity/api/interconnect/tasks/" + interconnectTaskId;
        return Observable
        .interval(INTERVAL)
        .startWith(0)
        .switchMap(() => {
            return this.http.get(URL);
        });
    }

}




// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/icc.service.ts